import { forwardRef, React, useImperativeHandle, useRef } from 'react';
import styled from 'styled-components';

import LinkManagerLogoPath from '../../../image/LinkManagerLogo.png';

const LogoView = forwardRef((props, ref) => {
	const { isOver } = props;
	const TopLevelRef = useRef();

	useImperativeHandle(ref, () => ({
		setOpacity: (val) => {
			if (val === 0) {
				TopLevelRef.current.style.opacity = val;
			}
			else {
				TopLevelRef.current.style.transform = val;
			}
		}
	}))

	return (
		<TopLevelWrapper ref={TopLevelRef} isOver={isOver}>
			<ViewWrapper isOver={isOver}>
				<LogoWrapper>
					<Logo src={LinkManagerLogoPath} /> 
				</LogoWrapper>
				<TextWrapper>
					<MainName>LINKO ZONE</MainName>
					<Explanation isOver={isOver}>AI가 도와주는 가장 쉬운 회원관리, 링코</Explanation>
				</TextWrapper>
			</ViewWrapper>
		</TopLevelWrapper>
	)
});

export default LogoView;

const TopLevelWrapper = styled.div`
	display: flex;
	flex-direction: column;

	justify-content: center;
	align-items: center;
	
	// width: 449px;
	width: ${props => props.isOver ? `max(449px, 58.46354166666667vw)` : `max(290px, 90.625vw)`};
	min-height: 92px;

  	margin-bottom: 10px;

	border-radius: 10px;
	box-shadow: 0px 40px 50px rgba(240, 232, 227, 0.5);

	background-color: #FF8B48;

	overflow: hidden; 
`;

const ViewWrapper = styled.div`
	display: flex;
	flex-direction: row;

	justify-content: center;
	align-items: center;

	gap: 10px;
`;

const LogoWrapper = styled.div`
	display: flex;
	flex-direction: column;
`;

const Logo = styled.img`
	width: 68px;
	height: 68px;

    filter: drop-shadow(0px 0px 25px rgba(240, 113, 39, 1));
`;

const TextWrapper = styled.div`
	display: flex;
	flex-direction: column;

	justify-content: center;
	align-items: center;
`;

const MainName = styled.p`
	font-family: NotoSansKR-Bold;
	font-size: 25px;

	color: rgba(255, 255, 255, 1);
		
	margin: 0 0 0 0;

	cursor: default;
`;

const Explanation = styled.p`
	font-family: NotoSansKR-Regular;
	// font-size: 12px;
	font-size: 10px;

	color: #FFFFFF;

	margin: 0 0 0 0;
	opacity: 0.7;
		
	cursor: default;
`;
